module.exports = __webpack_public_path__ + "img/read_w.6be76397.png";